/* SDEARLY presale price display. Display only: checkout price comes from the SD Presale Discount app. */
(function () {
  var S = window.SDP; if (!S) return;
  var SALE = {"46468265967865": 3099, "45771401756921": 2799, "45771401789689": 2799, "42475620040953": 1649, "43904708772089": 1649, "43450634928377": 1649, "43919183872249": 1649, "43447431659769": 1649, "47323921613049": 4099, "46654417207545": 5499, "45534338711801": 2799, "45534339105017": 2799, "43827643285753": 419, "67463917109497": 4699, "47182127071481": 1599, "46287011479801": 899, "45867906171129": 2799, "46882832482553": 5499, "46654595399929": 6299, "67463917240569": 6899, "46612234076409": 2799, "46526553096441": 3899, "46583611654393": 4199, "46882788606201": 6099, "47234320630009": 10999, "47234786820345": 5599, "46730513776889": 8999, "46654064591097": 5199, "46992652894457": 4299, "46627948560633": 4999, "45356955861241": 325, "45185943470329": 1099, "46447030796537": 325, "43466630725881": 599, "43466630693113": 779, "46564520919289": 325, "42297683345657": 560, "45175941890297": 629, "43466634756345": 479, "43466634723577": 599, "45176198398201": 499}; /* Gayatri sheet, 4 Nov 2026: variant id -> sale price (Rs) */
  function ck(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function applied() { return ck('discount_code').toUpperCase() === S.code; }
  function presale(p, c, v) { var t = SALE[String(v)]; return t && t * 100 < p ? t * 100 : p; }
  function fmt(p) { return '₹' + Math.round(p / 100); }
  function setText(el, t) { if (el && el.textContent.trim() !== t) el.textContent = t; }

  function paint(fp, p, c, v) {
    if (!fp || !c) return;
    var np = presale(p, c, v); if (np >= p) return;
    var off = Math.round((c - np) * 100 / c) + '% Off';
    fp.classList.add('f-price--on-sale');
    fp.querySelectorAll('.f-price-item--sale, .f-price__regular .f-price-item--regular').forEach(function (e) { setText(e, fmt(np)); });
    fp.querySelectorAll('s.prod__compare_price').forEach(function (e) { setText(e, fmt(c)); });
    fp.setAttribute('data-sdp', '1');
    var scope = fp.closest('.sf__pcard, .prod__reviews-and-prices, .main-product__block-price, .psa__info') || fp.parentElement;
    scope.querySelectorAll('.prod__tag-discounted .sf-currency--saved, .f-price__badge-sale .prod__tag-saving').forEach(function (e) { setText(e, off); });
  }

  function variantId() {
    var u = new URLSearchParams(location.search).get('variant'); if (u && S.variants[u]) return u;
    var i = document.querySelector('form[action*="/cart/add"] [name="id"]:not([disabled])'); if (i && S.variants[i.value]) return i.value;
    return Object.keys(S.variants)[0];
  }

  function run() {
    if (!applied()) return;
    if (S.page === 'collection') {
      document.querySelectorAll('.sf__pcard-price .f-price').forEach(function (fp) {
        var card = fp.closest('.sf__pcard') || fp.closest('[class*="pcard"]') || fp.parentElement.parentElement.parentElement;
        var a = card && card.querySelector('a[href*="/products/"]'); if (!a) return;
        var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
        var d = S.cards[h]; if (d) paint(fp, d[0], d[1], d[2]);
      });
    } else {
      var d = S.variants[variantId()]; if (!d) return;
      document.querySelectorAll('.main-product__block-price .f-price, .sticky_custom_price .f-price, .psa__info .f-price').forEach(function (fp) { paint(fp, d[0], d[1], d[2]); });
      var np = presale(d[0], d[1], d[2]);
      if (np < d[0]) document.querySelectorAll('.product_page_clock').forEach(function (b) {
        b.querySelectorAll('.preorder_atc').forEach(function (e) { setText(e, fmt(np)); });
        b.querySelectorAll('span:not([class])').forEach(function (e) { if (/^\u20b9\s*\d+$/.test(e.textContent.trim())) setText(e, fmt(d[1] - np)); });
      });
    }
  }

  var t; function later() { clearTimeout(t); t = setTimeout(run, 120); }
  function start() {
    run();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', later, true);
  }
  function apply() {
    if (applied() || !S.autoApply) return Promise.resolve();
    return fetch('/discount/' + S.code + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  function go() { apply().then(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
